import React from 'react';

import { Fab, TableRow, TableCell } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import TrplSelect from '../../../common/TrplControls/TrplSelect';
import AutocompleteSelect from '../../../common/AutocompleteSelect';

export default ({ classes, newCron, cronTimeKeys, addNewCronClick, restrictionsOptions, onNewCronFieldChange }) => {
  const predicateValue = restrictionsOptions.find((option) => option.value === newCron.pid);

  return (
    <TableRow>
      <TableCell className={classes.w200}>
        <TrplSelect
          margin="none"
          onChange={(e) => {
            onNewCronFieldChange('action', e.target.value);
          }}
          value={newCron.action}
          complicatedValues
          values={[
            {
              value: 'trpl_del',
              title: 'Trpl deletion',
            },
          ]}
        />
      </TableCell>

      <TableCell style={{ width: '250px' }}>
        <AutocompleteSelect
          value={predicateValue || ''}
          options={restrictionsOptions}
          onChange={(option) => {
            onNewCronFieldChange('pid', option.value);
          }}
        />
      </TableCell>

      <TableCell className={classes.w200}>
        <TrplSelect
          margin="none"
          complicatedValues
          value={newCron.strategy}
          onChange={(e) => {
            onNewCronFieldChange('strategy', e.target.value);
          }}
          values={[
            {
              value: 'create_time',
              title: 'Creation time',
            },
            {
              value: 'upd_time',
              title: 'Update time',
            },
          ]}
        />
      </TableCell>

      <TableCell className={classes.w200}>
        <TrplSelect
          margin="none"
          complicatedValues
          values={cronTimeKeys}
          value={newCron.value.time}
          onChange={(e) => {
            const value = { units: 'h' };

            value.time = e.target.value;

            onNewCronFieldChange('value', value);
          }}
        />
      </TableCell>

      <TableCell className={classes.w200}>
        <TrplSelect
          margin="none"
          complicatedValues
          values={[
            {
              title: 'Every 20 minutes',
              value: '20',
            },
            {
              title: 'Every 40 minutes',
              value: '40',
            },
            {
              title: 'Every hour',
              value: '60',
            },
          ]}
          value={newCron.period.time}
          onChange={(e) => {
            const value = { units: 'm' };

            value.time = e.target.value;

            onNewCronFieldChange('period', value);
          }}
        />
      </TableCell>

      <TableCell className={classes.w200}>
        <Fab
          size="small"
          color="primary"
          variant="circular"
          onClick={addNewCronClick}
          style={{
            flexShrink: '0',
            zoom: '0.8',
          }}
        >
          <AddIcon />
        </Fab>
      </TableCell>
    </TableRow>
  );
};
